import { Action } from '@ngrx/store';

export enum GridActionTypes {
  ResetState = '[Grid] Reset State'
}

export class ResetState implements Action {
  readonly type = GridActionTypes.ResetState;
}

export type GridActions = | ResetState;
